<script lang="ts" setup>
import type { ComputedRef } from 'vue'
import type { StudentProgress } from '../../models/Activity'
import { KsProgress } from '@aschehoug/kloss'
import { computed } from 'vue'

const props = defineProps<{
  studentList: StudentProgress[]
}>()

const baseSectionCount: ComputedRef<number> = computed(() => {
  return Math.max(...props.studentList.map((progress) => { return progress.sectionCount }))
})

</script>

<template>
  <section class="space-y-6">
    <div
      v-for="progress in studentList"
      :key="progress.user.userId"
      class="grid w-full grid-cols-8 items-center gap-4"
    >
      <p
        class="col-span-3 overflow-x-hidden text-ellipsis whitespace-nowrap font-medium"
        v-text="`${progress.user.firstName} ${progress.user.lastName.charAt(0)}`"
      />
      <KsProgress
        class="col-span-3"
        :max="baseSectionCount"
        :values="[progress.read]"
      />
      <p
        class="col-span-1 text-sm"
        v-text="progress.read + '/' + baseSectionCount"
      />
      <p
        v-if="progress.lastInteraction"
        class="col-span-1 text-sm"
        v-text="progress.lastInteraction"
      />
    </div>
  </section>
</template>
